{
  "blockType": "cta-banner",
  "root": {
    "animation": {
      "enter": {
        "curve": "ease-out",
        "duration": 400,
        "opacity": [
          0,
          1
        ],
        "translateY": [
          12,
          0
        ]
      },
      "scroll": {
        "once": true,
        "threshold": 0.3,
        "trigger": "inView"
      }
    },
    "children": [
      {
        "children": [
          {
            "children": [
              {
                "className": "text-lg font-semibold text-primary-foreground",
                "id": "banner-title",
                "text": "Ready to build your next big thing?",
                "type": "text"
              },
              {
                "className": "text-sm text-primary-foreground/80",
                "id": "banner-subtitle",
                "text": "Join 50,000+ creators shipping faster with Cogo.",
                "type": "text"
              }
            ],
            "className": "flex flex-col items-center gap-1 text-center sm:items-start sm:text-left",
            "id": "banner-text-group",
            "type": "container"
          },
          {
            "className": "shrink-0 min-h-11",
            "icon": "arrow-right",
            "iconPosition": "right",
            "id": "banner-cta",
            "interaction": {
              "cursor": "pointer",
              "hover": {
                "scale": 1.04,
                "shadow": "md"
              },
              "press": {
                "scale": 0.97
              },
              "transition": {
                "curve": "ease-out",
                "duration": 180,
                "properties": [
                  "transform",
                  "box-shadow"
                ]
              }
            },
            "size": "default",
            "text": "Start for Free",
            "type": "button",
            "variant": "secondary"
          }
        ],
        "className": "mx-auto flex max-w-6xl flex-col items-center justify-between gap-4 sm:flex-row cogo-gap-element",
        "id": "banner-inner",
        "type": "container"
      }
    ],
    "className": "bg-primary px-6 py-5",
    "id": "cta-banner-root",
    "type": "section"
  },
  "schemaVersion": "2.0"
}
